import React, { useEffect } from 'react';
import { Box, FormControl, Grid, InputLabel, Select, Typography } from '@material-ui/core';
import _ from 'lodash';

export default function SelectionStep({ store, formData, handleChangeData, isFinished }) {
    useEffect(() => {
        const { mobilePlatform, appType, isNewApp } = formData;
        const platformOk = !_.isEmpty(mobilePlatform);
        const typeOk = !_.isEmpty(appType);
        const newAppOk = appType === 'testing' || _.isBoolean(isNewApp);
        isFinished(platformOk && typeOk && newAppOk);
    }, [formData]);

    const handleSelect = (e) => {
        let value = e.target.value;
        if (value === 'true') value = true;
        else if (value === 'false') value = false;
        handleChangeData(e.target.name, value);
    };

    const storeName = formData.mobilePlatform === 'android'
        ? 'Google Play'
        : formData.mobilePlatform === 'ios'
            ? 'App Store'
            : 'Loja de aplicativos';

    return (
        <Grid container direction="column">
            <Box mt={2} mb={2}>
                <InputLabel>Plataforma</InputLabel>
                <FormControl fullWidth>
                    <Select
                        native
                        name="mobilePlatform"
                        value={formData.mobilePlatform}
                        onChange={handleSelect}
                    >
                        <option value="">Selecione</option>
                        <option value="android">Android</option>
                        <option value="ios">iOS</option>
                    </Select>
                </FormControl>
            </Box>

            <Box mt={2} mb={2}>
                <InputLabel>Ambiente</InputLabel>
                <Box mt={1} mb={1}>
                    <Typography>
                        <strong>Produção</strong> gera o build final para a {storeName}.{' '}
                        <strong>Homologação</strong> gera um APK (Android) ou IPA Ad Hoc (iOS) para validação interna.
                    </Typography>
                </Box>
                <FormControl fullWidth>
                    <Select
                        native
                        name="appType"
                        value={formData.appType}
                        disabled={!formData.mobilePlatform}
                        onChange={handleSelect}
                    >
                        <option value="">Selecione</option>
                        <option value="production">Produção</option>
                        <option value="testing">Homologação</option>
                    </Select>
                </FormControl>
            </Box>

            {formData.appType === 'production' && (
                <Box mt={2} mb={2}>
                    <InputLabel>Aplicativo novo</InputLabel>
                    <Box mt={1} mb={1}>
                        <Typography>
                            Indique se essa é a primeira vez que este aplicativo é publicado na {storeName}.
                        </Typography>
                    </Box>
                    <FormControl fullWidth>
                        <Select
                            native
                            name="isNewApp"
                            value={formData.isNewApp}
                            disabled={!formData.mobilePlatform}
                            onChange={handleSelect}
                        >
                            <option value="">Selecione</option>
                            <option value={true}>Sim — primeira publicação</option>
                            <option value={false}>Não — atualização</option>
                        </Select>
                    </FormControl>
                </Box>
            )}
        </Grid>
    );
}
